import { SystemUser } from './system-user';

export class Guide {

    constructor(
        public name: string,
        public comment: string,
        public id?: number,
        public createdBy?: SystemUser
    ){}
}
